module.exports = __webpack_public_path__ + "static/img/hgzx.5ae2ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hgzx.jpg
// module id = 59Gk
// module chunks = 0